import { useState } from "react";
import { assetLogoUrl } from "../api";

// Renders a coin's real logo when available (and loadable), else the themed letter/icon fallback.
export const CoinBadge = ({ logo, cls, icon, symbol, size = 28 }) => {
  const [bad, setBad] = useState("");
  return logo && bad !== logo ? (
    <img
      src={assetLogoUrl(logo)}
      alt={symbol || ""}
      className="coin-logo-img"
      onError={() => setBad(logo)}
      style={{ width: size, height: size, borderRadius: "50%", objectFit: "cover", flex: "0 0 auto" }}
    />
  ) : (
    (!icon || icon === "●") && symbol ? (
      <span className="coin-letter-badge" style={{ width: size, height: size, borderRadius: "50%", flex: "0 0 auto", display: "inline-flex", alignItems: "center", justifyContent: "center", background: "#f0b90b", color: "#1a1500", fontWeight: 800, fontSize: Math.round(size * 0.45) }}>{symbol[0]}</span>
    ) : <span className={`bd-coin ${cls || "usdt"}`}>{icon}</span>
  );
};

export default CoinBadge;
